import { render, staticRenderFns } from "./TrainingCard.vue?vue&type=template&id=276444e7&scoped=true"
import script from "./TrainingCard.vue?vue&type=script&lang=js"
export * from "./TrainingCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingCard.vue?vue&type=style&index=0&id=276444e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276444e7",
  null
  
)

export default component.exports